import "./index.css";

import { Grid, Layout, Spin, message } from "antd";
import React, { useEffect, useState } from "react";

import BulletinBoard from "../layout-components/BulletinBoard";
import Footer from "../layout-components/Footer";
import HeaderNav from "../layout-components/HeaderNav";
import { MenuOutlined } from "@ant-design/icons";
import SideBar from "../layout-components/SideBar";
import SideBarCourses from "../Content/SideBarCourses";
import { api } from "../../services/api";
import { useAuth } from "../../hooks/useAuth";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const AppLayout = ({ children }) => {
  const location = useLocation();
  const breakpoints = useBreakpoint();
  const [collapsed, setCollapsed] = useState(false);
  const { user, profile, setProfile, logout, ...auth } = useAuth();

  const [loading, setLoading] = useState(true);

  const isDynamicRoute = () => {
    const pathname = location.pathname;
    const pathArray = pathname.split("/");
    return pathArray.length >= 3 && pathArray[1] === 'mycourses' && pathArray[2] !== ''
  };

  const toggle = () => {
    setCollapsed(!collapsed);
  };



  const {
    isLoading: contractIsLoading,
    isFetching: contractIsFetching,
    error: contractsError,
    data: contracts,
  } = useQuery({
    queryKey: ["contracts"],
    queryFn: async () => {

      try {
        const { data: res } = await api.post("/authenticate-as", {
          franchise_hash: profile?.hash,
          role_id: profile?.role_id,
        });

        if (!profile.is_panel) return logout()


        setProfile({ ...profile, ...res.data });
        return res;
      } catch (error) {
        message.error("Você não tem permissão para acessar essa área");
        logout()
      }
    },
    cacheTime: 100000,
    staleTime: 6000,
    retryDelay: 10,
  });

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 500)

  }, []);

  const [viewPortWidth, setViewPortWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setViewPortWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);




  if (loading) return (
    <Spin
      size="large"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}

    ></Spin>
  )


  console.log(viewPortWidth)



  return (
    !(viewPortWidth >= 1305) ? (
      <Layout
        id="layout-md"
        style={{ flexDirection: "column", minHeight: '100vh' }}

      >
        <HeaderNav toggle={toggle} collapsed={collapsed} />
        <div style={{ padding: "20px 0", height: '100%' }}>
          {children}
          <BulletinBoard />
        </div>

        <Footer />
      </Layout>
    ) : (
      <Layout id="layout-lg"
        style={{ minHeight: '100vh' }}

      >
        <HeaderNav toggle={toggle} collapsed={collapsed} />
        <Layout style={{ gap: "30px", height: '100%' }}>
          <Content>
            <Layout>
              {breakpoints.md ? (isDynamicRoute() ? <SideBarCourses /> : <SideBar />) : null}
              <Content>{children}</Content>
              <BulletinBoard />
            </Layout>
          </Content>
        </Layout>
        <Footer />
      </Layout>
    )


  );
};
export default AppLayout;
